// extracted by mini-css-extract-plugin
module.exports = {"seatsLegendModalButton__button":"seatsLegendModalButton__button-fzENI"};